import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

import * as tournamentActions from "../actions/tournamentActions";

export const getTournamentById = createAsyncThunk(
  "publicTournament/getTournamentById",
  async (tournamentId, { rejectWithValue }) => {
    try {
      const response = await tournamentActions.getTournamentById(tournamentId);
      // Backend returns paginated shape { results: [...], totalResults, ... }.
      // Normalise to the array consumers expect.
      return response?.results || [];
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const initialState = {
  selectedTournament: null,
  selectedCategory: null,
  loading: false,
  error: null,
};

const publicTournamentSlice = createSlice({
  name: "publicTournament",
  initialState,
  reducers: {
    setSelectedTournament: (state, action) => {
      state.selectedTournament = action.payload;
    },
    setSelectedCategory: (state, action) => {
      state.selectedCategory = action.payload;
    },
    clearPublicTournament: (state) => {
      state.selectedTournament = null;
      state.selectedCategory = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getTournamentById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getTournamentById.fulfilled, (state, action) => {
        state.loading = false;
        state.tournaments = action.payload;
        if (action.payload.length > 0) {
          const tournament = action.payload[0];
          state.selectedTournament = tournament;
          // Set default category if available
          if (tournament.categories?.length > 0) {
            state.selectedCategory = tournament.categories[0];
          }
        }
      })
      .addCase(getTournamentById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const {
  setSelectedTournament,
  setSelectedCategory,
  clearPublicTournament,
} = publicTournamentSlice.actions;

export default publicTournamentSlice.reducer;
